var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.Pokaz)?_c('div',[_c('div',{class:_vm.Dane.KlasaOrganizacja},_vm._l((_vm.Karty),function(pozycja,index){return _c('div',{key:pozycja.index,class:_vm.Dane.Klasa},[_c('MyCard',{attrs:{"Id":_vm.Karty[index]}})],1)}),0)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }